// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/sign.css
// module id = 2673
// module chunks = 2